import React, { useState } from 'react'
import ElipsisImage from 'images/ellipsis-50px'
import { withRouter } from 'react-router'

const OccurrenceRowButton = ({text, disabled, spinning, onClick}) =>
  <button className={`btn btn-sm btn-outline-primary occurrence-row-btn ${spinning ? 'spinning' : ''}`}
    disabled={disabled || spinning}
    onClick={spinning ? null : onClick}
  >
    {spinning && <img src={ElipsisImage} className="occurrence-row-btn-spinner" />}
    <span>{text}</span>
  </button>

const OccurrenceReservationLink = ({ occurrence, base, event }) =>
  <span>
    { !event.waitlistedItemsId.includes(occurrence.id) &&
      (event.reservation_restricted ? (
        <button
          className="btn btn-sm btn-outline-secondary occurrence-row-btn"
          disabled
          title={event.restriction_reason}
        >
          {event.restriction_reason || "Reservation Restricted"}
        </button>
      ) : (
        <Link className={`btn btn-sm btn-outline-primary occurrence-row-btn`}
          to={`${base}/${occurrence.event.uid}::reserve:${occurrence.id}`}
        >
          <span>{occurrence.occurrence_waitlist ? "Join Waitlist" : "Reserve"}</span>
        </Link>
      ))
    }
  </span>

const OccurrenceModifyReservationLink = ({ occurrence, base, event }) =>
  <span>
    { !event.waitlistedItemsId.includes(occurrence.id) &&
      <Link className={`btn btn-sm btn-outline-primary occurrence-row-btn`}
        to={`${base}/${occurrence.event.uid}::modifyReservation:${occurrence.id}`}
      >
        <span>Modify Reservation</span>
      </Link>
    }
  </span>

const OccurrenceRow = (props) => {
  // State
  const [performing, setPerforming] = useState()

  // consts
  let { event, occurrence, relationship = occurrence.relationship || {}, base } = props
  console.log(event)
  console.log(relationship)

  // Custom Methods
  const runOccurreneAction = async (occurrence, action) => {
    let { event, base, history } = props

    if (User.current && User.current.guest) {
      App.state.setObjectSilent({ afterSignupPath: App.path })
      App.go(`${props.base}/guest-signup`)
      return
    }

    delete App.state.objects.interruptedReservation
    if (action == 'reserveOccurrence' || action == 'modifyReservation' && event.is_payment && !App.user.hasCard) {
      App.state.objects.interruptedReservation = {
        eventId: event.id, occurrenceId: event.occurrence_id, path: `${base}/${event.uid}`
      }
      history.push("/settings/payment")
      return
    }

    setPerforming(true)
    await event[action](occurrence)
    setPerforming(null)
  }

  // Render
  return [
    <tr className={"occurrence-row"} key="main">
      <td className="occurrence-row-date event-information-detail">{occurrence.dateText}</td>
      <td className="occurrence-row-time event-information-detail">{occurrence.timeText}</td>
      {event.isRecurring &&
        <>
          <td className="occurrence-row-spots">
            {relationship.is_reserved &&
              <span className='badge' title={`${relationship.spots} spots reserved`}>{relationship.spots}</span>
            }
          </td>
          <td className="occurrence-row-actions">
            <div className="occurrence-row-button">
              { console.log(event) }
              {
                occurrence.cancelled ? null :
                  event.is_enrollment_required && !event.isEnrolled && event.isReservation ?
                    <OccurrenceRowButton text="Enrollment Required" disabled /> :
                      event.isEnrolled && !relationship.is_reserved && !relationship.is_waitlisted ?
                        (!User.current?.guest ?
                          <OccurrenceReservationLink occurrence={occurrence} base={base} event={event} />
                          : null
                        ) :
                          (relationship.is_reserved && relationship.can_be_cancelled && event.is_cancelable && event.reservation_modifiable) ?
                            <>
                              <OccurrenceRowButton text="Cancel Reservation" onClick={() => runOccurreneAction(occurrence, 'cancelOccurrence')} spinning={performing} />
                              <OccurrenceModifyReservationLink occurrence={occurrence} base={base} event={event} />
                            </>:
                              (relationship.is_reserved && relationship.can_be_cancelled && event.is_cancelable) ?
                                <OccurrenceRowButton text="Cancel Reservation" onClick={() => runOccurreneAction(occurrence, 'cancelOccurrence')} spinning={performing} /> :
                                  (relationship.is_reserved && event.reservation_modifiable) ?
                                    <OccurrenceModifyReservationLink occurrence={occurrence} base={base} event={event} /> :
                                      (relationship.is_waitlisted && event.is_cancelable) ?
                                        <OccurrenceRowButton text="Cancel Waitlisted Reservation" onClick={() => runOccurreneAction(occurrence, 'cancelOccurrence')} spinning={performing} /> :
                                          (relationship.is_reserved && relationship.can_be_cancelled && !event.is_cancelable) || (relationship.is_waitlisted && !event.is_cancelable) ?
                                            (relationship.is_waitlisted ? "In Waiting List" : "Reserved") : 
                                              event.isReservation?
                                                (!User.current?.guest && !application.path.includes('/embed-calendar') ?
                                                  <OccurrenceReservationLink occurrence={occurrence} base={base} event={event} />
                                                  : null
                                                ) :
                                                  !event.isInterested ?
                                                    relationship.subscription_status == 'interested' ?
                                                      <OccurrenceRowButton text="Remove Reminder" onClick={() => runOccurreneAction(occurrence, 'cancelInterestInOccurrence')} spinning={performing} /> :
                                                      <OccurrenceRowButton text="Set Reminder" onClick={() => runOccurreneAction(occurrence, 'interestInOccurrence')} spinning={performing} /> :
                                                    null
              }
            </div>
          </td>
        </>
      }
    </tr>,
    occurrence.note &&
      <tr className={classNames("occurrence-note-row", {cancelled: occurrence.cancelled})} key="note">
        <td className="occurrence-row-note" colSpan={3}>
          {occurrence.note}
        </td>
      </tr>
  ]
}

export default withRouter(OccurrenceRow)
